// Base API URL of every backend service

export const API_URL = import.meta.env.WEB_API_URL

// Service-specific API paths

export const ONBOARDING_SERVICE_PATH = import.meta.env.ONBOARDING_WEB_API_PATH

export const GOTOMOBILE_SERVICE_PATH = import.meta.env.GO_TO_MOBILE_WEB_API_PATH

export const JOINTSIGNING_SERVICE_PATH = import.meta.env.JOINT_SIGNING_WEB_API_PATH

export const GOCARDLESS_SERVICE_PATH = import.meta.env.GOCARDLESS_WEB_API_PATH

export const EID_SERVICE_PATH = import.meta.env.EID_WEB_API_PATH

export const EASYSIGN_SERVICE_PATH = import.meta.env.EASY_SIGN_WEB_API_PATH

export const SIGNING_SERVICE_PATH = import.meta.env.SIGNING_WEB_API_PATH

export const READID_SERVICE_PATH = import.meta.env.READID_WEB_API_PATH

export const DATA_COLLECTION_SERVICE_PATH = import.meta.env.DATA_COLLECTION_WEB_API_PATH

export const AGE_VERIFICATION_SERVICE_PATH = import.meta.env.AGE_VERIFICATION_WEB_API_PATH

export const WALLET_VERIFICATION_SERVICE_PATH = import.meta.env.WALLET_VERIFICATION_WEB_API_PATH
